import { UAParser } from 'ua-parser-js';
import { Device } from '../support/Device';

const supportedBrowsers: { names: string[], minVersion: number }[] = [
    { names: ['Chrome', 'Chrome Headless'], minVersion: 115 }, // 07/2023
    { names: ['Firefox'], minVersion: 115 }, // 07/2023
    { names: ['Edge'], minVersion: 113 }, // 04/2023
    { names: ['Safari', 'Mobile Safari'], minVersion: 15 }, // 09/2021
];

export class Unsupported {

    static inject = () => [Device];
    constructor(private device: Device) {}

    isUnsupported = () => {
        // supported if native app
        if (this.device.platform !== 'web') {
            return false;
        }
        // supported if local storage override
        if (window.localStorage.getItem('ap:enable-web-access') === 'true') {
            return false;
        }
        // supported if test page
        if ((window.location.search.indexOf('?__test') === 0)) {
            return false;
        }
        // not supported if web on ios/android
        if (this.device.operatingSystem === 'ios' || this.device.operatingSystem === 'android') {
            return true;
        }
        // supported if browser meets requirements
        const { name, version } = new UAParser().getBrowser();
        if (supportedBrowsers.some(sb => sb.names.includes(name || '') && Number(version?.split('.')[0]) >= sb.minVersion)) {
            return false;
        }
        // otherwise, not supported
        return true;
    };

}
